{
  "familyId": "GELD-RENTE-PROC",
  "questions": [
    {
      "id": "GELD-RENTE-PROC-001", "familyId": "GELD-RENTE-PROC", "module": "Geld", "tier": 13, "levelCode": "B8", "group": 8, "skill": "geld_toegepast", "subSkill": "geld_rente_procent", "questionType": "multiple_choice",
      "question": "Je zet €500 op een spaarrekening met 4% rente per jaar. Hoeveel rente ontvang je na 1 jaar?",
      "options": ["€20", "€200", "€2", "€40"], "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Rente berekenen", "content": "Rente = bedrag × percentage ÷ 100. Dus: €500 × 4 ÷ 100 = €20. Of: 4% van €500 = €500 × 0,04 = €20.", "icon": "lightbulb" } }],
      "conceptId": "rente_basis", "variantIndex": 1, "citoDifficulty": 0.30, "citoDiscrimination": 0.75,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "4% van €500 = €500 × 4 ÷ 100 = €20. Na 1 jaar heb je €500 + €20 = €520 op je rekening.",
        "solutionSteps": ["Rente = bedrag × percentage ÷ 100", "€500 × 4 = 2000", "2000 ÷ 100 = €20", "Antwoord: €20 rente"],
        "distractorExplanations": { "0": "Goed! 4% van €500 = €20.", "1": "Je dacht waarschijnlijk dat je €500 × 4 = €2000 en dan ÷ 10 = €200. Maar je moet door 100 delen, niet door 10. 4% = 4 per 100. Onthoud: procent = per honderd.", "2": "Je dacht waarschijnlijk dat je €500 × 4 = €2000 en dan ÷ 1000 = €2. Maar je moet door 100 delen. Onthoud: procent = per honderd, dus deel door 100.", "3": "Je dacht waarschijnlijk dat 4% × 2 = 8% en dan €500 × 8 ÷ 100 = €40. Maar de rente is 4% per jaar, niet 8%. Onthoud: gebruik het percentage dat gegeven is." }
      }
    },
    {
      "id": "GELD-RENTE-PROC-002", "familyId": "GELD-RENTE-PROC", "module": "Geld", "tier": 13, "levelCode": "B8", "group": 8, "skill": "geld_toegepast", "subSkill": "geld_rente_procent", "questionType": "multiple_choice",
      "question": "Na 1 jaar met 3% rente heb je €309 op je spaarrekening. Hoeveel had je er in het begin op gezet?",
      "options": ["€300", "€306", "€290", "€309"], "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Terugrekenen bij rente", "content": "Na 3% rente heb je 103% van het oorspronkelijke bedrag. Dus: €309 ÷ 1,03 = €300. Of: €309 = 103%, dus 1% = €3, en 100% = €300.", "icon": "lightbulb" } }],
      "conceptId": "rente_terugrekenen", "variantIndex": 2, "citoDifficulty": 0.42, "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "Na 3% rente heb je 103% van het begin. €309 = 103%. Dus 1% = €309 ÷ 103 = €3. En 100% = €3 × 100 = €300. Check: 3% van €300 = €9. €300 + €9 = €309 ✓.",
        "solutionSteps": ["€309 = 103% (100% + 3% rente)", "1% = €309 ÷ 103 = €3", "100% = €3 × 100 = €300", "Check: 3% van €300 = €9, €300 + €9 = €309 ✓"],
        "distractorExplanations": { "0": "Goed! €309 ÷ 1,03 = €300. Check: 3% van €300 = €9, €300 + €9 = €309.", "1": "Je dacht waarschijnlijk dat je €309 − 3 = €306. Maar 3% van €300 = €9, niet €3. Onthoud: 3% is niet hetzelfde als €3.", "2": "Je dacht waarschijnlijk dat je €309 − 19 = €290. Maar de rente was maar €9 (3% van €300). Onthoud: bereken het percentage van het oorspronkelijke bedrag.", "3": "Je dacht waarschijnlijk dat €309 het beginbedrag is. Maar €309 is het bedrag NA de rente. Het beginbedrag was €300. Onthoud: na rente is het bedrag altijd hoger dan het begin." }
      }
    },
    {
      "id": "GELD-RENTE-PROC-003", "familyId": "GELD-RENTE-PROC", "module": "Geld", "tier": 13, "levelCode": "B8", "group": 8, "skill": "geld_toegepast", "subSkill": "geld_rente_procent", "questionType": "multiple_choice",
      "question": "Je spaart €1.000 met 5% rente per jaar. Na 2 jaar heb je (zonder samengestelde rente):",
      "options": ["€1.100", "€1.050", "€1.500", "€1.010"], "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Rente over meerdere jaren", "content": "Bij enkelvoudige rente: rente per jaar × aantal jaren. 5% van €1.000 = €50 per jaar. Na 2 jaar: 2 × €50 = €100 rente. Totaal: €1.000 + €100 = €1.100.", "icon": "lightbulb" } }],
      "conceptId": "rente_meerdere_jaren", "variantIndex": 3, "citoDifficulty": 0.35, "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "5% van €1.000 = €50 per jaar. Na 2 jaar: 2 × €50 = €100 rente. Totaal: €1.000 + €100 = €1.100.",
        "solutionSteps": ["Rente per jaar: 5% van €1.000 = €50", "Na 2 jaar: 2 × €50 = €100 rente", "Totaal: €1.000 + €100 = €1.100"],
        "distractorExplanations": { "0": "Goed! €50 rente per jaar × 2 jaar = €100 totale rente. €1.000 + €100 = €1.100.", "1": "Je dacht waarschijnlijk dat je maar 1 jaar rente krijgt. Maar na 2 jaar krijg je 2 × €50 = €100. Onthoud: vermenigvuldig de jaarlijkse rente met het aantal jaren.", "2": "Je dacht waarschijnlijk dat 5% × 2 jaar = 50% rente. Maar 5% per jaar × 2 = 10% totaal, niet 50%. €1.000 × 10% = €100. Onthoud: tel de percentages op, vermenigvuldig ze niet.", "3": "Je dacht waarschijnlijk dat de rente €5 per jaar is. Maar 5% van €1.000 = €50, niet €5. Onthoud: 5% = 5 per 100, dus €1.000 × 5 ÷ 100 = €50." }
      }
    },
    {
      "id": "GELD-RENTE-PROC-004", "familyId": "GELD-RENTE-PROC", "module": "Geld", "tier": 13, "levelCode": "B8", "group": 8, "skill": "geld_toegepast", "subSkill": "geld_rente_procent", "questionType": "multiple_choice",
      "question": "Je zet €1.000 op een spaarrekening met 10% rente per jaar. Na het eerste jaar krijg je rente over €1.000. Na het tweede jaar krijg je rente over het nieuwe bedrag (samengestelde rente). Hoeveel heb je na 2 jaar?",
      "options": ["€1.210", "€1.200", "€1.100", "€1.300"], "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Samengestelde rente", "content": "Bij samengestelde rente krijg je in het tweede jaar rente over je rente. Jaar 1: €1.000 × 1,10 = €1.100. Jaar 2: €1.100 × 1,10 = €1.210. Dat is €10 meer dan bij enkelvoudige rente (€1.200).", "icon": "lightbulb" } }],
      "conceptId": "rente_samengesteld", "variantIndex": 4, "citoDifficulty": 0.48, "citoDiscrimination": 0.68,
      "pedagogy": { "dok": 3 },
      "feedback": {
        "explanationText": "Bij samengestelde rente krijg je in het tweede jaar ook rente over de rente van het eerste jaar. Jaar 1: €1.000 × 1,10 = €1.100. Jaar 2: €1.100 × 1,10 = €1.210. Het verschil met enkelvoudige rente (€1.200) is €10 — dat is de 'rente op rente'.",
        "solutionSteps": ["Jaar 1: €1.000 × 1,10 = €1.100", "Jaar 2: €1.100 × 1,10 = €1.210", "Verschil met enkelvoudig: €1.210 − €1.200 = €10 extra", "Controleer: 10% van €1.100 = €110. €1.100 + €110 = €1.210 ✓"],
        "distractorExplanations": { "0": "Goed! €1.000 → €1.100 → €1.210. De extra €10 is rente op de rente van jaar 1.", "1": "Je dacht waarschijnlijk aan enkelvoudige rente: 2 × €100 = €200 rente, totaal €1.200. Maar bij samengestelde rente krijg je in jaar 2 ook rente over de €100 rente van jaar 1: 10% van €100 = €10 extra. Totaal: €1.210.", "2": "Je dacht waarschijnlijk aan maar 1 jaar rente. Maar de vraag gaat over 2 jaar. Na 1 jaar: €1.100. Na 2 jaar: €1.210. Onthoud: vermenigvuldig voor elk jaar opnieuw.", "3": "Je dacht waarschijnlijk dat 10% per jaar × 2 jaar = 30%. Maar 10% + 10% = 20% (enkelvoudig) of 21% (samengesteld). €1.000 × 1,21 = €1.210, niet €1.300." }
      }
    },
    {
      "id": "GELD-RENTE-PROC-005", "familyId": "GELD-RENTE-PROC", "module": "Geld", "tier": 13, "levelCode": "B8", "group": 8, "skill": "geld_toegepast", "subSkill": "geld_rente_procent", "questionType": "fill_in",
      "question": "Je zet €800 op een spaarrekening met 2,5% rente per jaar. Hoeveel rente krijg je na 1 jaar? Typ het bedrag in euro's (bijv. 20).",
      "options": [], "correctAnswer": "20",
      "data": { "acceptedAnswers": ["20", "€20", "20,00"], "caseSensitive": false, "placeholder": "€..." },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Rente met kommapercentage", "content": "2,5% van €800: reken eerst 1% = €8. Dan 2,5 × €8 = €20. Of: €800 × 2,5 ÷ 100 = €20.", "icon": "lightbulb" } }],
      "conceptId": "rente_komma_percentage", "variantIndex": 5, "citoDifficulty": 0.38, "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "2,5% van €800: eerst 1% = €800 ÷ 100 = €8. Dan 2,5 × €8 = €20. Je krijgt €20 rente na 1 jaar.",
        "solutionSteps": ["1% van €800 = €8", "2,5% = 2,5 × €8 = €20", "Antwoord: €20 rente"]
      }
    },
    {
      "id": "GELD-RENTE-PROC-006",
      "familyId": "GELD-RENTE-PROC",
      "module": "Geld",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_rente_procent",
      "questionType": "step_solver",
      "question": "Je zet €2.000 op een spaarrekening met 5% samengestelde rente per jaar. Reken stap voor stap uit hoeveel je na 2 jaar hebt.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "stepSolver": {
          "context": "",
          "steps": [
            {
              "prompt": "Hoeveel heb je na jaar 1? (€2.000 × 1,05 = ...)",
              "correctAnswer": "2100",
              "acceptedAnswers": ["2100", "€2.100", "2.100", "€2100", "2100,00"],
              "hint": "Vermenigvuldig het startbedrag met 1,05 (= 100% + 5%)"
            },
            {
              "prompt": "Hoeveel rente krijg je in jaar 2? (5% van €2.100 = ...)",
              "correctAnswer": "105",
              "acceptedAnswers": ["105", "€105", "105,00", "€105,00"],
              "hint": "Bereken 5% van het bedrag na jaar 1"
            },
            {
              "prompt": "Hoeveel heb je na jaar 2 in totaal? (€2.100 + rente jaar 2 = ...)",
              "correctAnswer": "2205",
              "acceptedAnswers": ["2205", "€2.205", "2.205", "€2205", "2205,00"],
              "hint": "Tel de rente van jaar 2 op bij het bedrag na jaar 1"
            }
          ],
          "showStepsProgressively": true
        }
      },
      "conceptId": "rente_samengesteld_step_solver", "variantIndex": 6, "citoDifficulty": 0.50, "citoDiscrimination": 0.67,
      "pedagogy": { "dok": 3 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Samengestelde rente stap voor stap",
            "content": "Bij samengestelde rente bereken je elk jaar de rente over het NIEUWE bedrag. Jaar 1: €2.000 × 1,05 = €2.100. Jaar 2: €2.100 × 1,05 = €2.205. Het verschil met enkelvoudige rente (€2.200) is €5 — dat is de 'rente op rente'.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bij samengestelde rente krijg je elk jaar rente over het nieuwe bedrag. Jaar 1: €2.000 × 1,05 = €2.100. Jaar 2: 5% van €2.100 = €105. Totaal na 2 jaar: €2.100 + €105 = €2.205. Bij enkelvoudige rente zou het €2.200 zijn — de extra €5 is rente op de rente van jaar 1.",
        "solutionSteps": [
          "Jaar 1: €2.000 × 1,05 = €2.100",
          "Jaar 2: 5% van €2.100 = €105",
          "Totaal: €2.100 + €105 = €2.205",
          "Verschil met enkelvoudig: €2.205 − €2.200 = €5 extra (rente op rente)"
        ]
      }
    },
    {
      "id": "GELD-RENTE-PROC-007",
      "familyId": "GELD-RENTE-PROC",
      "module": "Geld",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "geld_toegepast",
      "subSkill": "geld_rente_procent",
      "questionType": "true_false_series",
      "question": "Zijn deze beweringen over rente waar of onwaar?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "3% rente per jaar over €400 levert na 1 jaar €12 rente op.", "isTrue": true },
          { "text": "Als je na 1 jaar met 5% rente €525 hebt, had je €500 op je rekening gezet.", "isTrue": true },
          { "text": "Bij samengestelde rente van 10% per jaar heb je na 2 jaar precies 20% meer dan het startbedrag.", "isTrue": false },
          { "text": "2% rente per jaar over €1.000 levert na 3 jaar (enkelvoudig) €60 rente op.", "isTrue": true }
        ]
      },
      "conceptId": "rente_true_false_misconceptions", "variantIndex": 7, "citoDifficulty": 0.48, "citoDiscrimination": 0.66,
      "pedagogy": { "dok": 3 },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Veelgemaakte fouten bij rente",
            "content": "Fout: denken dat samengestelde rente hetzelfde is als enkelvoudige rente. Bij samengestelde rente krijg je rente over je rente. 10% per jaar × 2 jaar samengesteld = 21% totaal (niet 20%). Enkelvoudig: 10% + 10% = 20%. Samengesteld: 1,10 × 1,10 = 1,21 = 21%.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Stelling 1: Waar — 3% van €400 = €12. Stelling 2: Waar — €525 ÷ 1,05 = €500. Controleer: 5% van €500 = €25, €500 + €25 = €525 ✓. Stelling 3: Onwaar — bij samengestelde rente van 10% per jaar heb je na 2 jaar 1,10 × 1,10 = 1,21 = 21% meer, niet precies 20%. Het verschil is de 'rente op rente'. Stelling 4: Waar — 2% van €1.000 = €20 per jaar. Na 3 jaar enkelvoudig: 3 × €20 = €60.",
        "solutionSteps": [
          "Stelling 1: 3% van €400 = €12 ✓ (Waar)",
          "Stelling 2: €525 ÷ 1,05 = €500 ✓ (Waar)",
          "Stelling 3: 1,10 × 1,10 = 1,21 = 21%, niet 20% (Onwaar)",
          "Stelling 4: 3 × (2% van €1.000) = 3 × €20 = €60 ✓ (Waar)"
        ]
      }
    }
  ]
}